import React from 'react';
import {
  Typography,
} from '@mui/material';
import { Trans } from '@gamiphy/react-i18n';
import { observer } from 'mobx-react';
import { CirclesCard } from '../components/circles';
import { Tabs } from '../store/ui';
import Tab from '../components/cashback/cashbackProgram/loggedIn/components/Tab';

const ReferralTab: React.FC = () => (
  <Tab
    tab={Tabs.Referral}
    header={(
      <Typography fontSize={16} fontWeight={700}>
        <Trans
          i18nKey="shared.referral"
          defaults="Referral"
        />
      </Typography>
    )}
  >
    <CirclesCard />
  </Tab>
);

export default observer(ReferralTab);
